const fold = (s: string) =>
  s
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/đ/gi, 'd')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim();

/**
 * The catalog entry a free-text value read off a document refers to: "CHUỐI
 * GIÀ" → "Chuối già", "Đất trồng cây lâu năm (CLN)" → "Đất trồng cây lâu năm".
 * Exact (accent- and case-insensitive) first, then whichever contains the
 * other, longest name winning. Undefined when nothing fits — a select backed by
 * a catalog must not be handed a value it cannot show.
 */
export function matchCatalogName(text: string | undefined, names: string[]): string | undefined {
  if (!text) return undefined;
  const t = fold(text);
  if (!t) return undefined;
  const exact = names.find((n) => fold(n) === t);
  if (exact) return exact;
  return names
    .filter((n) => {
      const f = fold(n);
      return f.length >= 3 && (t.includes(f) || f.includes(t));
    })
    .sort((a, b) => b.length - a.length)[0];
}
